import { authorize, putRequest } from '../../../utils/http';
import { AWS_API_URL } from '../../../global/environment';

export async function updateUserIn2nAPI(user, data) {
  const url = `${AWS_API_URL}/2n/users/${user?.Id}`;

  return putRequest(url, {
    data: {
      groupIds: data?.groupsAndPermissions?.map((group) => group?.value),
      isSuspended: data?.isSuspended,
    },
  }, await authorize());
}
